import { GithubOutlined } from '@ant-design/icons';
import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="Powered by NHACHINHCHU24H"
      links={[
        {
          key: 'NHACHINHCHU24H ADMIN SYSTEM',
          title: 'NHACHINHCHU24H ADMIN SYSTEM',
          href: '#',
          blankTarget: true,
        },
        {
          key: 'github',
          title: <GithubOutlined />,
          href: '#',
          blankTarget: true,
        },
        {
          key: '',
          title: '',
          href: '#',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
